import { CREATE_USER } from "../../constants/Urls";
import ResponseInstanceModel from "../../models/features/api/ResponseInstanceModel";
import IResult from "../../models/result/IResult";
import { sendDelete, sendGet } from "./generic";


export const getResponse = (responseId: string): Promise<IResult<any>> => {
    return sendGet<any>("/Response/" + responseId);
}


export const deleteResponse = (responseId: string): Promise<IResult<any>> => {
    return sendDelete<any>("/Response/" + responseId);
}

export const getResponsesForApplication = (appId: string, skip: number = 0, take: number = 200): Promise<IResult<ResponseInstanceModel[]>> => {
    return sendGet<any>("/Response/application/" + appId + "?skip=" + skip + "&take=" + take);
}